import template from './price-rent-commercial.jade';
import priceTypeOptions from '../../../enums/price-type';
import validation from './../../../services/validation';
import { firstLetterToUpperCase } from '@cian/ui/app/services/utils.jsm';

export default angular
  .module('cian.addForm.priceRentCommercial', [])
  .directive('cianAfPriceAndDealTermsPriceRentCommercial', () => ({
    scope: {},
    bindToController: {
      ad: '=',
      form: '=',
    },
    controller(deviceService) {
      'ngInject';
      this.isMobile = deviceService.isMobile;
      this.ad.bargainTerms = this.ad.bargainTerms || {};
      this.priceTypeItems = priceTypeOptions;
      this.validation = validation(this.form, 'bargainTerms.priceType', {
        required: 'Укажите тип цены',
      });

      const setPricePeriodAndType = priceTypeStr => {
        switch (priceTypeStr) {
          case 'allMonthly':
            this.ad.bargainTerms.priceType = 'all';
            this.ad.bargainTerms.paymentPeriod = 'monthly';
            break;
          case 'squareMeterMonthly':
            this.ad.bargainTerms.priceType = 'squareMeter';
            this.ad.bargainTerms.paymentPeriod = 'monthly';
            break;
          case 'squareMeterAnnual':
            this.ad.bargainTerms.priceType = 'squareMeter';
            this.ad.bargainTerms.paymentPeriod = 'annual';
            break;
        }
      };

      if (angular.isString(this.ad.bargainTerms.priceType) && angular.isString(this.ad.bargainTerms.paymentPeriod)) {
        const priceType = this.ad.bargainTerms.priceType + firstLetterToUpperCase(this.ad.bargainTerms.paymentPeriod);
        if (this.priceTypeItems.find(item => item.value === priceType)) {
          this.priceType = priceType;
        }
      }

      if (!this.priceType) {
        this.priceType = this.priceTypeItems[0].value;
      }

      setPricePeriodAndType(this.priceType);

      this.handlePriceTypeChange = () => setPricePeriodAndType(this.priceType);
    },
    controllerAs: 'priceRentCommercial',
    template,
  })).name;
